import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import { formatApiKeyType } from "components/ApiKeys/utils";

import { CellComponentProps } from "../types";

type ApiKeysListItemTypeCellProps = CellComponentProps;

const ApiKeysListItemTypeCell = ({ apiKey }: ApiKeysListItemTypeCellProps) => {
  return (
    <Box fullWidth gap="large">
      <Typography tag="span" variant="p-body3">
        {formatApiKeyType(apiKey.type)}
      </Typography>
    </Box>
  );
};

export default ApiKeysListItemTypeCell;
